/* =============================================================
   baitishk-patches.js
   Small targeted fixes that don't belong in the main custom JS.
   Loaded after baitishk-custom.js in theme.liquid.

   NOTE: The old PATCH 2 (cart-recommendations swiper 'auto' fix) was
   removed — it competed with the swiper fix in baitishk-custom.js
   (which sets slidesPerView=2). Two scripts setting different values
   on the same Swiper caused the intermittent / inconsistent carousel
   behaviour. baitishk-custom.js is now the single authority.
   ============================================================= */

(function () {
  'use strict';

  /* -----------------------------------------------------------
   * PATCH 1: ATC button shows raw HTML money format
   * Root cause: shop.money_format is '<span class=money>{{amount}}</span>'.
   * The theme sets element.textContent = formattedString, so the literal
   * '<span ...>' renders as text. Fix: when a .product-addtocart-btn's
   * text contains a literal '<span', convert textContent -> innerHTML.
   * ----------------------------------------------------------- */
  function fixMoneyHtml(btn) {
    if (!btn) return;
    var raw = btn.textContent || '';
    if (raw.indexOf('<span') !== -1 || raw.indexOf('<SPAN') !== -1) {
      btn.innerHTML = raw;
    }
  }

  function fixAllMoneyBtns() {
    document.querySelectorAll('.product-addtocart-btn').forEach(fixMoneyHtml);
  }

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('.baitishk-qty-input') ||
      e.target.matches('input[name="quantity"]') ||
      e.target.matches('.quantity__input')
    ) {
      setTimeout(fixAllMoneyBtns, 80);
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.matches('.baitishk-qty-btn')) {
      setTimeout(fixAllMoneyBtns, 80);
    }
  }, true);

  var moneyObserver = new MutationObserver(function (muts) {
    muts.forEach(function (mut) {
      if (mut.type === 'characterData') {
        var el = mut.target.parentElement;
        if (el && el.classList.contains('product-addtocart-btn')) {
          fixMoneyHtml(el);
        }
      }
      if (mut.type === 'childList' && mut.target.classList && mut.target.classList.contains('product-addtocart-btn')) {
        fixMoneyHtml(mut.target);
      }
    });
  });

  function observeAtcBtns() {
    document.querySelectorAll('.product-addtocart-btn').forEach(function (btn) {
      moneyObserver.observe(btn, { childList: true, characterData: true, subtree: true });
    });
  }

  new MutationObserver(function (muts) {
    muts.forEach(function (mut) {
      mut.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('product-addtocart-btn')) {
          fixMoneyHtml(node);
          moneyObserver.observe(node, { childList: true, characterData: true, subtree: true });
        }
        node.querySelectorAll && node.querySelectorAll('.product-addtocart-btn').forEach(function (btn) {
          fixMoneyHtml(btn);
          moneyObserver.observe(btn, { childList: true, characterData: true, subtree: true });
        });
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fixAllMoneyBtns();
      observeAtcBtns();
    });
  } else {
    fixAllMoneyBtns();
    observeAtcBtns();
  }

  /* -----------------------------------------------------------
   * PATCH 3: Safari mobile — slideshow hero text invisible
   * motion-effect[slideshow] elements start at opacity:0 and animate in
   * on a Swiper event; on iOS Safari that race can leave them invisible.
   * Force them visible after the animation window.
   * ----------------------------------------------------------- */
  function fixSlideshowVisibility() {
    var selectors = [
      '.section__slideshow motion-effect',
      '.swiper-slideshow-main motion-effect',
      '.slideshow motion-effect'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var style = window.getComputedStyle(el);
        if (parseFloat(style.opacity) < 0.1) {
          el.style.setProperty('opacity', '1', 'important');
          el.style.setProperty('transform', 'none', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.setProperty('transition', 'none', 'important');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(fixSlideshowVisibility, 600);
      setTimeout(fixSlideshowVisibility, 1500);
    });
  } else {
    setTimeout(fixSlideshowVisibility, 600);
    setTimeout(fixSlideshowVisibility, 1500);
  }

  new MutationObserver(function (muts) {
    muts.forEach(function (mut) {
      mut.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (
          node.classList && (
            node.classList.contains('section__slideshow') ||
            node.classList.contains('swiper-slideshow-main')
          )
        ) {
          setTimeout(fixSlideshowVisibility, 800);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: false });

  /* -----------------------------------------------------------
   * PATCH 4: Cart PAGE live-refresh after a recommendation add
   * On /cart there is no <cart-drawer> to re-render, so the Baitishk add
   * paths (variant-picker drawer ATC, single rec add, bundle) update the
   * header badge but leave the cart line items stale until a manual
   * reload. Those paths all dispatch 'cart:updated' / 'cart:refresh'.
   * On the cart page only, re-render the cart section in place via a
   * section-rendering fetch, with a full-reload fallback. Normal cart
   * quantity changes use the theme's own pub/sub (not these DOM events),
   * so this never fires for them.
   * ----------------------------------------------------------- */
  function btkOnCartPage() {
    var p = window.location.pathname.replace(/\/+$/, '');
    return /\/cart$/.test(p) || (document.body && document.body.classList.contains('template-cart'));
  }

  var btkCartRefreshBusy = false;
  var btkCartRefreshPending = null;

  function btkFindCartSection() {
    var anchor =
      document.querySelector('[name="updates[]"]') ||
      document.querySelector('cart-items') ||
      document.querySelector('.cart-items') ||
      document.querySelector('form[action*="/cart"]');
    return anchor ? anchor.closest('[id^="shopify-section-"]') : null;
  }

  function btkRefreshCartSection() {
    if (btkCartRefreshBusy) return;
    var section = btkFindCartSection();
    if (!section || !section.id) { window.location.reload(); return; }
    btkCartRefreshBusy = true;
    fetch(window.location.pathname, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(section.id);
        if (fresh) { section.replaceWith(fresh); }
        else { window.location.reload(); }
      })
      .catch(function () { window.location.reload(); })
      .then(function () { btkCartRefreshBusy = false; });
  }

  function btkScheduleCartRefresh() {
    if (!btkOnCartPage()) return;
    clearTimeout(btkCartRefreshPending);
    btkCartRefreshPending = setTimeout(btkRefreshCartSection, 350);
  }

  document.addEventListener('cart:updated', btkScheduleCartRefresh);
  document.addEventListener('cart:refresh', btkScheduleCartRefresh);

  /* -----------------------------------------------------------
   * PATCH 5: Single-variant recommendation add on the CART PAGE
   * A single-variant rec card uses the theme's native <product-form>,
   * which on /cart has no cart-drawer/notification to target and so
   * falls back to a full-page navigation to the cart URL (a reload).
   * Intercept the add for rec-section single-variant buttons on the
   * cart page, add via AJAX ourselves, update the header badge, then let
   * PATCH 4 re-render the cart section in place — matching the seamless
   * multi-variant "Choose Option" behaviour. Scoped to .baitishk-atc-btn
   * inside .main-cart-upsell-product on /cart, so it never touches the
   * cart's own line items or the drawer (where the native flow works).
   * ----------------------------------------------------------- */
  function btkUpdateHeaderBadge(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var badge = icon.querySelector('.cart-count.bg-sale');
    if (!badge) return;
    var num = badge.querySelector('.count');
    if (num) num.textContent = count < 100 ? String(count) : '~';
    var vh = badge.querySelector('.visually-hidden');
    if (vh) vh.textContent = String(count);
  }

  document.addEventListener('click', function (e) {
    if (!btkOnCartPage()) return;
    var btn = e.target.closest('.baitishk-atc-btn');
    if (!btn || !btn.closest('.main-cart-upsell-product')) return;
    var form = btn.closest('form');
    if (!form) return;
    var idEl = form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.dataset.btkBusy === '1') return;
    btn.dataset.btkBusy = '1';
    btn.disabled = true;

    var qEl = form.querySelector('[name="quantity"]');
    var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
    var labelEl = btn.querySelector('.product-addtocart-btn');
    var origLabel = labelEl ? labelEl.textContent : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(idEl.value), quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        if (labelEl) labelEl.textContent = '✓';
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { btkUpdateHeaderBadge(c.item_count || 0); })
          .catch(function () {});
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          btn.disabled = false;
          btn.dataset.btkBusy = '';
          if (labelEl) labelEl.textContent = origLabel;
        }, 1500);
      })
      .catch(function (err) {
        console.warn('[Baitishk] cart-page single rec add:', err);
        btn.disabled = false;
        btn.dataset.btkBusy = '';
        if (labelEl) labelEl.textContent = origLabel;
      });
  }, true);

  /* -----------------------------------------------------------
   * PATCH 6: Cart-drawer "You may also like" — RTL + re-render white-screen fix
   * The drawer recommendations are a theme <slide-section> Swiper loaded
   * async by <mini-cart-recommendations>. On every qty change the theme
   * wipes & re-renders .drawer__cart-recommendations (innerHTML) and it
   * re-fetches; module-slide.js inits Swiper in its constructor with no
   * observer, no watchOverflow and no rtl flag — so the carousel can init
   * while the drawer is hidden/empty (zero-width or stale translate) and
   * land on a blank "white" panel, and RTL translate is left to chance.
   * This makes the rec carousel resilient: after any drawer open / cart
   * change / rec re-render, re-measure the Swiper (update), reset to the
   * first slide, sync its direction to the document (EN + AR), and hide
   * the block when it has no slides so there is never a blank gap.
   * Scoped to the rec carousel only — never touches line items / totals /
   * ATC. Idempotent (needs-check) and wrapped in try/catch.
   * ----------------------------------------------------------- */
  (function () {
    function recSwipers() {
      return document.querySelectorAll('.drawer__cart-recommendations slide-section.swiper, .main-cart-upsell-product slide-section.swiper');
    }
    function docRtl() {
      return (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
    }
    function fixOne(el) {
      if (!el) return;
      var rtl = docRtl();
      if (rtl && el.getAttribute('dir') !== 'rtl') el.setAttribute('dir', 'rtl');
      if (!rtl && el.getAttribute('dir') === 'rtl') el.removeAttribute('dir');
      var sw = el.swiper;
      if (!sw) return;
      var realSlides = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
      var dirKey = rtl ? 'rtl' : 'ltr';
      var needs = (sw.width === 0) ||
        (sw.slides && sw.slides.length === 0 && realSlides > 0) ||
        (el.__btkSlides !== realSlides) ||
        (el.__btkDir !== dirKey);
      if (!needs) return;
      el.__btkSlides = realSlides;
      el.__btkDir = dirKey;
      try {
        if (typeof sw.changeLanguageDirection === 'function') {
          var cur = sw.rtlTranslate ? 'rtl' : 'ltr';
          if (dirKey !== cur) sw.changeLanguageDirection(dirKey);
        }
        sw.update();
        if (typeof sw.slideTo === 'function') sw.slideTo(0, 0, false);
      } catch (e) {}
    }
    function observeBoxes() {
      document.querySelectorAll('.drawer__cart-recommendations').forEach(function (box) {
        if (box.__btkObs) return;
        box.__btkObs = true;
        obs.observe(box, { childList: true, subtree: true });
      });
    }
    function fixAll() {
      document.querySelectorAll('.drawer__cart-recommendations').forEach(function (box) {
        var val = box.querySelector('.swiper-slide') ? '' : 'none';
        if (box.style.display !== val) box.style.display = val;
      });
      recSwipers().forEach(fixOne);
      observeBoxes();
    }
    var ts = [];
    function schedule() {
      ts.forEach(clearTimeout);
      ts = [100, 400, 900, 1600].map(function (d) { return setTimeout(fixAll, d); });
    }
    var obs = new MutationObserver(function () {
      clearTimeout(obs._t);
      obs._t = setTimeout(fixAll, 100);
    });
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].attributeName === 'class' && document.documentElement.classList.contains('open-modal')) { schedule(); break; }
        }
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
    ['cart:updated', 'cart:refresh', 'nextsky:cart:added'].forEach(function (ev) {
      document.addEventListener(ev, schedule);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { observeBoxes(); schedule(); });
    } else {
      observeBoxes();
      schedule();
    }
  })();

  /* -----------------------------------------------------------
   * PATCH 7: Stop the cart-drawer recommendation churn at its trigger
   * (companion to PATCH 6). The theme's ProductForm.updateCartDrawer
   * re-renders .drawer__cart-recommendations on EVERY qty change/remove,
   * wiping the async-loaded carousel and forcing a re-fetch — the source
   * of the intermittent blank panel and of needless network on each +/-
   * tap. We can't subclass the registered custom element, and editing the
   * vendor cart engine (module-add-to-cart.js, ~58KB) is a high-blast-
   * radius change on a live store. So we wrap that one method here: when a
   * working carousel already exists, hide the recommendations container
   * from the theme's own querySelector for the (synchronous) duration of
   * the re-render so it skips the rec wipe, then restore it immediately.
   * Cart items, totals, header badge and the free-shipping bar all still
   * update normally — only the recommendation refresh is suppressed,
   * keeping the cross-sell carousel stable across qty edits (better AOV
   * UX) with no re-fetch and no flash. Guarded + reversible; worst case it
   * simply no-ops. PATCH 6 remains the safety net.
   * ----------------------------------------------------------- */
  try {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-items').then(function () {
        var CI = customElements.get('cart-items');
        if (!CI || !CI.prototype) return;
        var proto = CI.prototype;
        var target = null;
        while (proto && proto !== HTMLElement.prototype) {
          if (Object.prototype.hasOwnProperty.call(proto, 'updateCartDrawer')) { target = proto; break; }
          proto = Object.getPrototypeOf(proto);
        }
        if (!target) return;
        var orig = target.updateCartDrawer;
        if (typeof orig !== 'function' || orig.__btkWrapped) return;
        var wrapped = function () {
          var reco = document.querySelector('.drawer__cart-recommendations');
          var lock = reco && reco.querySelector('.swiper-slide');
          if (lock) reco.classList.remove('drawer__cart-recommendations');
          try {
            return orig.apply(this, arguments);
          } finally {
            if (lock && reco) reco.classList.add('drawer__cart-recommendations');
          }
        };
        wrapped.__btkWrapped = true;
        target.updateCartDrawer = wrapped;
      }).catch(function () {});
    }
  } catch (e) {}

  /* -----------------------------------------------------------
   * PATCH 8: Branded preloader -- hard max-time cap
   * The theme's <page-loader> splash (assets/theme.js PageLoader) removes
   * itself on window.load, which waits for above-the-fold images + fonts.
   * On a weak connection (e.g. the Instagram in-app browser) that can keep
   * the full-screen terracotta cover up for several seconds on every page
   * navigation. Put an absolute ceiling on it: if the splash is still
   * present ~1.8s after navigation start, fade + remove it here so the
   * page is revealed (any remaining images then stream in via the theme's
   * lazy-loading). Fast loads are untouched -- the theme's own
   * window.load handler dismisses earlier and this no-ops. Additive,
   * reversible, and never blocks the theme's logic (querying a detached
   * node is harmless). Skips while a saved-scroll restore is in progress
   * so it never reveals a momentarily-hidden body.
   * ----------------------------------------------------------- */
  (function () {
    var CAP_MS = 1800;   // absolute ceiling, measured from navigation start
    var FADE_MS = 280;
    function dismiss() {
      if (document.documentElement.classList.contains('is-restoring-scroll')) {
        setTimeout(dismiss, 120);
        return;
      }
      var el = document.querySelector('page-loader.preloader') ||
               document.querySelector('page-loader');
      if (!el || el.__btkCapped) return;
      el.__btkCapped = true;
      try {
        el.style.transition = 'opacity ' + FADE_MS + 'ms ease';
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
        setTimeout(function () { if (el && el.parentNode) el.remove(); }, FADE_MS + 60);
      } catch (e) {
        if (el && el.parentNode) el.remove();
      }
    }
    function arm() {
      var elapsed = 0;
      try { elapsed = performance.now(); } catch (e) {}
      setTimeout(dismiss, Math.max(0, CAP_MS - elapsed));
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arm);
    } else {
      arm();
    }
  })();

})();
